module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("For Peter Ahlstrom")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("Who is not only a good friend and great man,")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("But one who has been reading my books since the days when they were terrible,")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("And who strives very hard to keep them from being that way again.")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("Insoluble, Incalculable, Indefinable. ")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("Indispensable.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff9ed77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ded.vue
// module id = 69
// module chunks = 0